"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serviceIdPattern = exports.pubKeyIdPattern = exports.delegatePubKeyIdPattern = exports.attributeNamePattern = exports.defaultProvider = exports.VoltaAddress1056 = void 0;
var did_resolver_interface_1 = require("@ew-did-registry/did-resolver-interface");
var did_1 = require("@ew-did-registry/did");
// Address of ERC1056 smart contract on Volta
exports.VoltaAddress1056 = '0xc15d5a57a8eb0e1dcbe5d88b8f9a82017e5cc4af';
exports.defaultProvider = {
    uriOrInfo: 'http://localhost:8544',
    type: did_resolver_interface_1.ProviderTypes.HTTP,
};
var pubKeyPattern = '0x[A-Fa-f0-9]{66}';
exports.attributeNamePattern = '^did/(pub|auth|svc)/(\\w+)(/(\\w+))?(/(\\w+))?$';
exports.delegatePubKeyIdPattern = "^did:[a-z0-9]+:" + did_1.ethAddrPattern + "#delegate-(sigAuth|veriKey)-(" + pubKeyPattern + "|" + did_1.ethAddrPattern + ")$";
exports.pubKeyIdPattern = "^did:[a-z0-9]+:" + did_1.ethAddrPattern + "#key-([A-Za-z0-9]+)";
exports.serviceIdPattern = "^did:[a-z0-9]+:" + did_1.ethAddrPattern + "#service-([A-Za-z0-9]+)";
//# sourceMappingURL=constants.js.map